<template>
    <div id="fiab-helper" class="pt-2">
        <h3>FIAB Helper Tools</h3>

        <h4>Optional Tags Checker</h4>
        <p>Add <a href="https://pastebin.com/0P8mHFPP" target="_blank">this userscript</a> to your browser to get a
            button to copy freeforms. Paste the output of the optional tags into the text box below. Any that aren't in
            the
            tagset will be listed.</p>
        <div v-if="!loaded" class="loader">
            <div class="loading loading-lg"></div>
        </div>

        <template v-else>

            <div class="form-horizontal columns">
                <div class="form-group column col-12">
                    <div class="col-4 col-sm-12">
                        <label class="form-label" for="tags">Freeform Tags</label>
                    </div>
                    <div class="col-8 col-sm-12">
                        <textarea id="tags" class="form-textarea" v-model="input"></textarea>
                    </div>
                </div>
            </div>

            <div>
                <p>
                    These tags are not nominated freeforms:

                </p>

                <ul>
                    <li v-for="tag in problemTags" :key="tag">
                        {{ tag }}
                    </li>
                </ul>

            </div>

        </template>
    </div>
</template>

<script>
// third party
import { map, filter, slice, each, includes } from "lodash-es";
import axios from "axios";

export default {
    name: "fiabhelper",
    beforeMount() {
        this.load();
    },
    data() {
        return {
            loaded: false,
            input: '',
            tagset: [],
        };
    },
    computed: {
        problemTags() {
            if (!this.input.length) return [];
            const parsedTags = this.input.split(',');

            const problemTags = [];
            each(parsedTags, tag => {
                if (!includes(this.tagset, tag.trim())) {
                    problemTags.push(tag)
                }
            })

            return problemTags
        }

    },
    methods: {
        async load() {
            await axios
                .get(`https://autoao3.herokuapp.com/db/exchange/Fic_In_A_Box_${String(new Date().getFullYear())}/freeforms`)
                .then((res) => {
                    this.tagset = map(res.data, t => t.tag);
                    this.loaded = true;
                });
        },
    }
};
</script>

<style lang="scss">
@import "../styles/app.scss";
@import "../styles/mobile.scss";

.text-small {
    font-size: 80%;
}

#tags {
    width: 100%;
    height: 80px;
}
</style>